exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-nav-link{color:#3b3b3b\n}\n.profile-nav-link:hover{color:#007fb1\n}\n.admin-link{color:#dc3545 !important\n}\n.admin-link:hover{color:#c82333 !important\n}", ""]);

// exports
